<mat-card *ngIf="!updateMode">{{'addSubService' | translate}}</mat-card>
<mat-card *ngIf="updateMode">{{'updatesubService' | translate}}</mat-card>

<div align="end" class="row" style="padding:10px 10px 0 0;">
    <span class="spacer"></span>

    <button mat-raised-button color="primary" (click)="submit()" *ngIf="!_submit"
        [disabled]="arabName.invalid || engName.invalid">
        <!-- || costPrice.invalid || price.invalid -->
        <mat-icon>done</mat-icon>
        {{'submit' | translate}}
    </button>
    <!-- &nbsp;
    <button mat-raised-button color="primary" (click)="addNew()" *ngIf="_submit">
        <mat-icon>add</mat-icon>
        {{'addNew' | translate}}
    </button> -->
    &nbsp;
    <button mat-raised-button (click)="back()">
        <mat-icon>keyboard_backspace</mat-icon>
        {{'back' | translate}}
    </button>
    &nbsp;
</div>

<mat-grid-list cols="9" rowHeight="100px">

    <mat-grid-tile colspan="3">
        &nbsp;
        <mat-form-field appearance="standard">
            <mat-label>{{'mainServices' | translate}}</mat-label>
            <mat-select [(value)]="subService.mainId" required #mainSelect (selectionChange)="onSelectMainCategory()">
                <mat-option *ngFor="let item of MainService" [value]="item.id">
                    {{item.arabicName}}
                </mat-option>
                <mat-error *ngIf="!subService.mainId">
                    {{'requiredField' | translate}}
                </mat-error>
            </mat-select>
        </mat-form-field>
        <span>&nbsp;</span>

    </mat-grid-tile>


    <mat-grid-tile colspan="3">
        <mat-form-field appearance="standard">
            <mat-label>{{'arabicName' | translate}}</mat-label>
            <input matInput [(ngModel)]="subService.arabicName" required #arabName="ngModel" name="arabicName">
            <mat-error *ngIf="arabName.invalid">{{'requiredField' | translate}}</mat-error>
        </mat-form-field>

    </mat-grid-tile>

    <mat-grid-tile colspan="3">
        <mat-form-field appearance="standard">
            <mat-label>{{'englishName' | translate}}</mat-label>
            <input matInput [(ngModel)]="subService.englishName" required #engName="ngModel" name="englishName">
            <mat-error *ngIf="engName.invalid">{{'requiredField' | translate}}</mat-error>
        </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="3" *ngIf="mainServiceObj.type == 1">
        <mat-form-field appearance="standard">
            <mat-label>{{'costPrice' | translate}}</mat-label>
            <input matInput [(ngModel)]="subService.costPrice" type="number" required name="costPrice">
        </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="3" *ngIf="mainServiceObj.type == 1">
        <mat-form-field appearance="standard">
            <mat-label>{{'price' | translate}}</mat-label>
            <input matInput [(ngModel)]="subService.price" type="number" required name="price">
        </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="3" *ngIf="mainServiceObj.type == 2">
        <mat-form-field appearance="standard">
            <mat-label>نوع الخصم</mat-label>
            <mat-select [(value)]="subService.commissionType" required #mainSelect
                (selectionChange)="onCommissionTypeChange()">
                <mat-option [value]="0"> عمولة</mat-option>
                <mat-option [value]="1"> نسبة</mat-option>
            </mat-select>
        </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="3" *ngIf="mainServiceObj.type == 2 && subService.commissionType == 1">
        <mat-form-field appearance="standard">
            <mat-label>النسبة</mat-label>
            <input matInput [(ngModel)]="subService.commissionPercent" type="number" required name="commissionPercent">

        </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="2">
        <mat-checkbox *ngIf="updateMode" class="example-margin" [(ngModel)]="subService.status" name="active">{{'active'
            |
            translate}}
        </mat-checkbox>
    </mat-grid-tile>

</mat-grid-list>


<mat-grid-list cols="3" rowHeight="200px">
    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile>
        <!-- <mat-label>Image</mat-label> -->
        <input type="file" class="dropify" (change)="onSelectImage($event)" />
    </mat-grid-tile>
</mat-grid-list>

<br />

<mat-accordion class="example-headers-align" multi>
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                ملاحظات
            </mat-panel-title>

        </mat-expansion-panel-header>
        <div [ngxSummernote]="config" [(summernoteModel)]="subService.notes"></div>

    </mat-expansion-panel>
</mat-accordion>


<app-matspinner [overlay]="spinnerOverlay"></app-matspinner>